import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import PageContext from '../../../config/page-settings.js';

import SystemLogsList from './SystemLogsList.js';

const SystemLogs = (props) => {
  const pageContext = useContext(PageContext);

  useEffect(() => {
    pageContext.handleSetPageSidebar(true);
    pageContext.handleSetPageHeader(true);
    pageContext.handleSetPageContentFullWidth(false);
  }, []);

  return (
    <div>
      <h1 className="page-header">System Logs</h1>
      <SystemLogsList />
    </div>
  );
};

export default withRouter(SystemLogs);
